import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Slider from 'react-slick';

import ShopWomen from './../../assets/shopWomens.jpg';
import Family from './../../assets/family.png';
import './styles.scss';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const categories = [
  {
    label: 'Womens',
    image: ShopWomen,
    path: '/search/womens',
  },
  {
    label: 'Kids',
    image: 'https://media.istockphoto.com/id/2096480418/photo/group-of-multi-cultural-children-friends-linking-arms-looking-down-into-camera.jpg?s=612x612&w=0&k=20&c=H0-_W5BfzoBd8VqKwsj353-25GCwsF5XRHVzitJ4ffQ=',
    path: '/search/kids',
  },
  {
    label: 'Mens',
    image: 'https://menshaircuts.com/wp-content/uploads/2019/06/business-casual-men-outfit-grey-big-cell.jpg',
    path: '/search/mens',
  },
];

const posterImages = [
  'https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&w=1400&q=80',
  'https://images.unsplash.com/photo-1556905055-8f358a7a47b2?auto=format&fit=crop&w=1400&q=80',
  'https://images.unsplash.com/photo-1556740749-887f6717d7e4?auto=format&fit=crop&w=1400&q=80',
  'https://images.unsplash.com/photo-1503602642458-232111445657?auto=format&fit=crop&w=1400&q=80',  // Tech lifestyle
  'https://images.unsplash.com/photo-1491553895911-0055eca6402d?auto=format&fit=crop&w=1400&q=80', // Fashionable outfit
  'https://images.unsplash.com/photo-1526170375885-4d8ecf77b99f?auto=format&fit=crop&w=1400&q=80', // Beauty products
  'https://images.unsplash.com/photo-1522337660859-02fbefca4702?auto=format&fit=crop&w=1400&q=80', // Kids toys & fun
  'https://images.unsplash.com/photo-1526170375885-4d8ecf77b99f?auto=format&fit=crop&w=1400&q=80', // Fragrance or perfume
  'https://images.unsplash.com/photo-1512436991641-6745cdb1723f?auto=format&fit=crop&w=1400&q=80', // Shoes & footwear
  'https://images.unsplash.com/photo-1512496015851-a90fb38ba796?auto=format&fit=crop&w=1400&q=80', // Fitness gear


];

const textVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.3,
      duration: 0.6,
      ease: 'easeOut',
    },
  }),
};

const Directory = () => {
  const sliderSettings = {
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <motion.div
      className="directory"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      {/* Poster Slider */}
      <div className="posterSlider">
        <Slider {...sliderSettings}>
          {posterImages.map((url, idx) => (
            <div key={idx}>
              <img
                src={url}
                alt={`Poster ${idx + 1}`}
                style={{ width: '100%', height: '333px', objectFit: 'cover', borderRadius: '12px' }}
              />
            </div>
          ))}
        </Slider>
      </div>

      {/* Categories */}
      <div className="categoryWrap">
        {categories.map((cat, index) => (
          <motion.div
            key={cat.label}
            className="categoryitem"
            style={{ backgroundImage: `url(${cat.image})` }}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.5 + index * 0.2, duration: 0.5 }}
            whileHover={{ scale: 1.05 }}
          >
            <Link to={cat.path}>{cat.label}</Link>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default Directory;
